module.exports = __webpack_public_path__ + "img/italic.880f7a1d.svg";